
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const EnglishPage = lazy(() => import('../pages/en/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const SuccessPage = lazy(() => import('../pages/success/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const ContactEnPage = lazy(() => import('../pages/contact-en/page'));
const SuccessEnPage = lazy(() => import('../pages/success-en/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/en',
    element: <EnglishPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/en/contact',
    element: <ContactEnPage />
  },
  {
    path: '/success',
    element: <SuccessPage />,
  },
  {
    path: '/en/success',
    element: <SuccessEnPage />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
